import React, { FC } from 'react'

interface UmbrellaIconProps {
  className?: string
  htmlColor?: string
}

const UmbrellaIcon: FC<UmbrellaIconProps> = ({ className, htmlColor }) => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    color={htmlColor}
  >
    <g clipPath='url(#umbrella_clip)'>
      <path
        d='M19 29.4348C19 31.5217 16 31.5217 16 29.4348V19'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16 3V1'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 19C16.9083 15.44 23.2626 15.44 24.171 19C24.1996 15.4133 31.0074 15.44 30.9829 19C31.3778 10.2627 24.8982 3 16 3C7.10179 3 0.622192 10.2627 1.01712 19C0.99261 15.44 7.80041 15.4133 7.82901 19C8.73735 15.44 15.0903 15.44 16 19Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='umbrella_clip'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default UmbrellaIcon
